<template>
  <content-panel class="platform-image-rule-config-page">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="90px" :model="searchForm">
          <el-form-item label="平台组">
            <platform-group-select v-model="searchForm.platformGroup" />
          </el-form-item>
          <el-form-item label="发布状态">
            <el-select v-model="searchForm.publishStatus" clearable filterable placeholder="请选择发布状态">
              <el-option label="待配置" value="PENDING_CONFIG" />
              <el-option label="已发布" value="PUBLISHED" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="queryRuleList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetSearch">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel>
      <el-table
        :data="ruleRows"
        border
        stripe
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="groupName" label="平台组" min-width="100" />
        <el-table-column prop="currentVersion" label="规则版本" min-width="120" />
        <el-table-column prop="statusDesc" label="发布状态" min-width="90">
          <template slot-scope="{ row }">
            <span :class="row.status === 'PUBLISHED' ? 'status-ok' : 'status-warn'">
              {{ row.statusDesc || row.status }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="190" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openConfigDialog(row)">配置规则</el-button>
            <el-button type="text" @click="openHistoryDialog(row)">查看历史版本</el-button>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>

    <rule-config-dialog
      v-if="configDialogVisible"
      :visible.sync="configDialogVisible"
      :config-row="currentConfigRow"
      @success="queryRuleList"
    />

    <rule-history-dialog
      v-if="historyDialogVisible"
      :visible.sync="historyDialogVisible"
      :history-row="currentHistoryRow"
    />
  </content-panel>
</template>

<script>
import PlatformGroupSelect from './components/PlatformGroupSelect.vue'
import RuleConfigDialog from './components/RuleConfigDialog.vue'
import RuleHistoryDialog from './components/RuleHistoryDialog.vue'

export default {
  name: 'PlatformImageRuleConfig',
  components: {
    PlatformGroupSelect,
    RuleConfigDialog,
    RuleHistoryDialog
  },
  data () {
    return {
      searchForm: {
        platformGroup: '',
        publishStatus: ''
      },
      ruleRows: [],
      configDialogVisible: false,
      historyDialogVisible: false,
      currentConfigRow: null,
      currentHistoryRow: null
    }
  },
  mounted () {
    this.queryRuleList()
  },
  methods: {
    async queryRuleList () {
      const res = await this.$q.newProduct.platformImageRuleList({
        params: {
          platformGroupCode: this.searchForm.platformGroup || undefined,
          status: this.searchForm.publishStatus || undefined
        }
      })
      this.ruleRows = res.data || []
    },
    resetSearch () {
      this.searchForm = {
        platformGroup: '',
        publishStatus: ''
      }
      this.queryRuleList()
    },
    openConfigDialog (row) {
      this.currentConfigRow = { ...row }
      this.configDialogVisible = true
    },
    openHistoryDialog (row) {
      this.currentHistoryRow = { ...row }
      this.historyDialogVisible = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.status-ok
  color #67c23a

.status-warn
  color #e6a23c

.search-box
  >>> .el-select,
  >>> .el-input
    width 240px !important
</style>
